import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';
import { RoleGuard } from './shared/guard/role.guard';
import { Role } from './shared/_helpers/models/role';
import { PageNotFoundComponent } from './authentication/page-not-found/page-not-found.component';
const ɵ0 = () => import("./website/website.module.ngfactory").then(m => m.WebsiteModuleNgFactory) //website
, ɵ1 = () => import("./authentication/authentication.module.ngfactory").then(m => m.AuthenticationModuleNgFactory) //login
, ɵ2 = () => import("./home/home.module.ngfactory").then(m => m.HomeModuleNgFactory), ɵ3 = {
    routingModule: 'dashboard',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
}, ɵ4 = () => import("./property/property.module.ngfactory").then(m => m.PropertyModuleNgFactory), ɵ5 = {
    routingModule: 'property',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
}, ɵ6 = () => import("./qsi/qsi.module.ngfactory").then(m => m.QsiModuleNgFactory), ɵ7 = {
    routingModule: 'qs_inspection',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR,
        Role.ROLE_BMV, Role.ROLE_RMV, Role.ROLE_LV]
}, ɵ8 = () => import("./rfp-management/rfp-management.module.ngfactory").then(m => m.RfpManagementModuleNgFactory), ɵ9 = {
    routingModule: 'rfp_management',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
}, ɵ10 = () => import("./configuration/configuration.module.ngfactory").then(m => m.ConfigurationModuleNgFactory), ɵ11 = {
    routingModule: 'configuration',
    roles: [Role.PORTAL_ADMIN]
}, ɵ12 = () => import("./reports/reports.module.ngfactory").then(m => m.ReportsModuleNgFactory), ɵ13 = {
    routingModule: 'reports',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
}, ɵ14 = () => import("./user/user.module.ngfactory").then(m => m.UserModuleNgFactory), ɵ15 = {
    routingModule: 'user',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
}, ɵ16 = () => import("./crew/crew.module.ngfactory").then(m => m.CrewModuleNgFactory), ɵ17 = {
    routingModule: 'crew',
    roles: [Role.ROLE_VENDOR]
}, ɵ18 = () => import("./customer/customer.module.ngfactory").then(m => m.CustomerModuleNgFactory), ɵ19 = {
    routingModule: 'customer',
    roles: [Role.PORTAL_ADMIN]
}, ɵ20 = () => import("./vendor/vendor.module.ngfactory").then(m => m.VendorModuleNgFactory), ɵ21 = {
    routingModule: 'vendor',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR, Role.ROLE_BMV, Role.ROLE_RMV]
}, ɵ22 = () => import("./history/history.module.ngfactory").then(m => m.HistoryModuleNgFactory), ɵ23 = {
    routingModule: 'history',
    roles: [Role.PORTAL_ADMIN]
}, ɵ24 = () => import("./work-order/work-order.module.ngfactory").then(m => m.WorkOrderModuleNgFactory), ɵ25 = {
    routingModule: 'work_order',
    roles: [Role.ROLE_VENDOR, Role.ROLE_PM]
}, ɵ26 = () => import("./view-data/view-data.module.ngfactory").then(m => m.ViewDataModuleNgFactory), ɵ27 = {
    routingModule: 'view_data',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
}, ɵ28 = () => import("./region-branch/region-branch.module.ngfactory").then(m => m.RegionBranchModuleNgFactory), ɵ29 = {
    routingModule: 'region_branch',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN]
}, ɵ30 = () => import("./extra-work-task/extra-work-task.module.ngfactory").then(m => m.ExtraWorkTaskModuleNgFactory), ɵ31 = {
    routingModule: 'extra_work_task',
    roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR, Role.ROLE_BMV, Role.ROLE_RMV]
};
const routes = [
    {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full'
    },
    {
        path: 'app',
        loadChildren: ɵ0 //website
    },
    {
        path: 'authentication',
        loadChildren: ɵ1 //login
    },
    {
        path: 'home',
        loadChildren: ɵ2,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ3
    },
    {
        path: 'property',
        loadChildren: ɵ4,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ5
    },
    {
        path: 'qs-inspection',
        loadChildren: ɵ6,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ7
    },
    {
        path: 'rfp-management',
        loadChildren: ɵ8,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ9
    },
    {
        path: 'configuration',
        loadChildren: ɵ10,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ11
    },
    {
        path: 'reports',
        loadChildren: ɵ12,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ13
    },
    {
        path: 'user',
        loadChildren: ɵ14,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ15
    },
    {
        path: 'crew',
        loadChildren: ɵ16,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ17
    },
    {
        path: 'customer',
        loadChildren: ɵ18,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ19
    },
    {
        path: 'vendor',
        loadChildren: ɵ20,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ21
    },
    {
        path: 'history',
        loadChildren: ɵ22,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ23
    },
    {
        path: 'work-order',
        loadChildren: ɵ24,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ25
    },
    {
        path: 'view',
        loadChildren: ɵ26,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ27
    },
    {
        path: 'region-branch',
        loadChildren: ɵ28,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ29
    },
    {
        path: 'extra-work-task',
        loadChildren: ɵ30,
        canActivate: [AuthGuard, RoleGuard],
        data: ɵ31
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31 };
